import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { Voucher } from 'src/features/vouchers/utils/types';

const RESOURCE = '/discounts/voucher/:voucherId/';

type QueryFnType = typeof queryFn;

interface DTO {
    voucherId: string;
}
const queryFn = ({ voucherId }: DTO): Promise<Voucher> => {
    return axios.get(formatResourcePath(RESOURCE, { voucherId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetVoucher, RESOURCE as VOUCHER_RESOURCE };
